"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sFavReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var SfavAction_1 = require("@/pages/search/actions/sfilter/SfavAction");
var SfavState_init_1 = require("@/pages/search/states/SfavState.init");
exports.sFavReducer = function (state, action) {
    if (state === void 0) { state = SfavState_init_1.defaultSfavState; }
    switch (action.type) {
        case typesafe_actions_1.getType(SfavAction_1.default.setRecentlyViewedList): {
            return __assign(__assign({}, state), { sectionHistory: __assign(__assign({}, state.sectionHistory), { items: action.payload, more: false }) });
        }
        case typesafe_actions_1.getType(SfavAction_1.default.onSetFavList): {
            return __assign(__assign({}, state), { sectionFav: __assign(__assign({}, state.sectionFav), { items: action.payload, more: action.payload.length > 4 }) });
        }
        case typesafe_actions_1.getType(SfavAction_1.default.setDesktopFav): {
            return __assign(__assign({}, state), { opened: action.payload });
        }
        case typesafe_actions_1.getType(SfavAction_1.default.setFavActive): {
            return __assign(__assign({}, state), { favActive: action.payload });
        }
        case typesafe_actions_1.getType(SfavAction_1.default.onSetSaveSearchList): {
            return __assign(__assign({}, state), { sectionSavedSearch: __assign(__assign({}, state.sectionSavedSearch), { items: action.payload }) });
        }
        case typesafe_actions_1.getType(SfavAction_1.default.onSetFollowingPlaceList): {
            return __assign(__assign({}, state), { sectionFollowingPlace: __assign(__assign({}, state.sectionFollowingPlace), { items: action.payload }) });
        }
        case typesafe_actions_1.getType(SfavAction_1.default.setRecentIsSaved): {
            var newItems = state.sectionHistory.items.map(function (it) {
                return (Number(it.referenceId) === Number(action.payload.id)) ? __assign(__assign({}, it), { isSaved: action.payload.state }) : it;
            });
            return __assign(__assign({}, state), { sectionHistory: __assign(__assign({}, state.sectionHistory), { items: newItems }) });
        }
        case typesafe_actions_1.getType(SfavAction_1.default.closeAllSubsection): {
            return __assign(__assign({}, state), { sectionFav: __assign(__assign({}, state.sectionFav), { opened: false }), sectionFavInt: __assign(__assign({}, state.sectionFavInt), { opened: false }), sectionHistory: __assign(__assign({}, state.sectionHistory), { opened: false }), sectionHistoryInt: __assign(__assign({}, state.sectionHistoryInt), { opened: false }), sectionFollowingPlace: __assign(__assign({}, state.sectionFollowingPlace), { opened: false }), sectionSavedSearch: __assign(__assign({}, state.sectionSavedSearch), { opened: false }) });
        }
        case typesafe_actions_1.getType(SfavAction_1.default.setSearchSetActive): {
            var newSectionFollowinPlace = __assign(__assign({}, state.sectionFollowingPlace), { items: state.sectionFollowingPlace.items.map(function (it) {
                    return (it.userSearchSetId === action.payload.userSearchSetId) ? __assign(__assign({}, it), { active: true }) : __assign(__assign({}, it), { active: false });
                }) });
            var newSectionSavedSearch = __assign(__assign({}, state.sectionSavedSearch), { items: state.sectionSavedSearch.items.map(function (it) {
                    return (it.userSearchSetId === action.payload.userSearchSetId) ? __assign(__assign({}, it), { active: true }) : __assign(__assign({}, it), { active: false });
                }) });
            return __assign(__assign({}, state), { sectionFollowingPlace: newSectionFollowinPlace, sectionSavedSearch: newSectionSavedSearch });
        }
    }
    return state;
};
